import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import Grid from '@zenbusiness/zui/Grid';
import Heading from '@zenbusiness/zui/Heading';
import PageHeader from '@zenbusiness/zui/PageHeader';
import Paper from '@zenbusiness/zui/Paper';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import { superstyled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const HelpPageHeader = superstyled({
  tag: PageHeader,
  name: 'HelpPage',
  slot: 'HelpPageHeader',
  styles: ({ theme }) => ({
    marginBottom: theme.spacing(4),
    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing(2),
    },
  }),
});

export const HelpBox = superstyled({
  tag: Paper,
  name: 'HelpPage',
  propsAdded: {
    variant: 'outlined',
  },
  slot: 'HelpBox',
  styles: ({ theme }) => ({
    padding: 32,

    marginBottom: theme.spacing(4),

    [theme.breakpoints.up('lg')]: {
      paddingLeft: 48,
      paddingRight: 48,
    },
  }),
});

export const HelpBoxLayout = superstyled({
  tag: Box,
  name: 'HelpPage',
  slot: 'HelpBoxLayout',
  propsAdded: {
    alignItems: 'flex-start',
    display: 'flex',
    justifyContent: 'flex-start',
  },
  styles: ({ theme }) => ({
    flexDirection: 'row',
    gap: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
  }),
});

export const ImageWrapper = superstyled({
  tag: Box,
  name: 'HelpPage',
  slot: 'ImageWrapper',
  propsAdded: {
    display: 'flex',
    xs: 12,
    sm: 2.5,
  },
});

export const HelpImage = superstyled({
  tag: SharedAsset,
  name: 'HelpPage',
  slot: 'HelpImage',
  styles: {
    display: 'block',
  },
});

export const HelpBoxHeader = superstyled({
  tag: Heading,
  propsAdded: {
    size: 'xl',
    weight: 'medium',
  },
});

export const HelpBoxContent = superstyled({
  tag: Text,
  name: 'HelpPage',
  slot: 'HelpBoxContent',
  propsAdded: {
    size: 'sm',
  },
  styles: ({ theme }) => ({
    marginBottom: theme.spacing(4),
  }),
});

export const HelpBoxContentWrapper = superstyled({
  tag: Grid,
  name: 'HelpPage',
  slot: 'HelpBoxContentWrapper',
  propsAdded: {
    container: true,
    item: true,
    direction: 'column',
    justifyContent: 'space-between',
    minHeight: 152,
    sm: 8.5,
    xs: 12,
  },
});

export const SearchButton = superstyled({
  tag: Button,
  name: 'HelpPage',
  slot: 'SearchButton',
  propsAdded: {
    color: 'primary',
    // TODO: Review the proper URL for this button
    href: 'https://help.zenbusiness.com/',
    target: '_blank',
    variant: 'contained',
  },
  styles: ({ theme }) => ({
    whiteSpace: 'nowrap',

    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  }),
});

export const SearchWrapper = superstyled({
  tag: Grid,
  name: 'HelpPage',
  slot: 'SearchWrapper',
  styles: {
    padding: '12px 0',
  },
});

export const SupportSectionHeader = superstyled({
  tag: Heading,
  name: 'HelpPage',
  slot: 'SupportSectionHeader',
  propsAdded: {
    size: 'xl',
    weight: 'medium',
  },
  styles: {
    marginBottom: 32,
  },
});
